import React from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Button, Checkbox, DatePicker, Input, Modal, Select } from 'antd'
import { users, agency } from '@services/api'
import { alertPopup } from '@utils/popup'
import moment from 'moment'

@inject((stores: any) => {
    const { popupStore, subscriptionsStore } = stores
    return { popupStore, subscriptionsStore }
})
@observer
class EditClientInfo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            agentPage: false,
            updateCommission: true,
            first_name: '',
            last_name: '',
            identity: '',
            passport: '',
            phone: '',
            email: '',
            birthday: undefined,
            parent_id: '',
            status: '',
            hmo_id: '',
            hmo_plan_id: '',
            fathers_name: '',
            agency_id: '',
            subscription_price: '',
            subscription_id: '',
            messages: {
                phone: '',
                email: '',
                parent_id: '',
                agency_id: ''
            },
            card_approval: ''
        }
    }

    componentDidMount() {
        this.setFields()
        if (this.props.match.path.includes('clients')) {
            this.setState({ agentPage: false })
        } else if (this.props.match.path.includes('agents')) {
            this.setState({ agentPage: true })
        }
    }

    componentDidUpdate(prevProps) {
        const prevClientInfo = prevProps.clientInfo
        const { clientInfo } = this.props
        const prevId = prevClientInfo && prevClientInfo.id
        const currentId = clientInfo && clientInfo.id
        const { popupType } = this.props.popupStore

        if (!currentId) return

        // Switched to a different client: always refresh the form fields.
        if (prevId !== currentId) {
            this.setFields()
            return
        }

        // Same client but the clientInfo object was refreshed (e.g. after a save).
        // Only refresh while the edit modal is closed so in-progress edits are not discarded.
        if (prevClientInfo !== clientInfo && popupType !== 'editClientInfo') {
            this.setFields()
        }
    }

    setFields = () => {
        const { clientInfo } = this.props

        this.setState({
            updateCommission: true,
            first_name: clientInfo.first_name,
            last_name: clientInfo.last_name,
            identity: clientInfo.identity,
            passport: clientInfo.passport,
            phone: clientInfo.identity ? 0 + clientInfo.phone : clientInfo.phone,
            email: clientInfo.email,
            birthday: clientInfo.birthday ? moment(clientInfo.birthday) : undefined,
            parent_id: clientInfo.parent_id,
            status: clientInfo.status,
            hmo_id: clientInfo.hmo_id ? this.hmos[clientInfo.hmo_id] : null,
            hmo_plan_id:
                clientInfo.hmo_id && clientInfo.hmo_plan_id
                    ? (this.hmoPlans[clientInfo.hmo_id] || {})[clientInfo.hmo_plan_id]
                    : null,
            fathers_name: clientInfo.fathers_name,
            related_as: clientInfo.related_as,
            agency_id: clientInfo.agency_id,
            subscription_price: clientInfo.subscription_price,
            subscription_id: clientInfo.subscription_id,
            card_approval: clientInfo.card_approval
        })
    }

    onClose = () => {
        this.setFields()
        this.props.popupStore.togglePopup(false)
    }

    handleInput = e => {
        const field = e.target.id.split('-')[1]
        let value = e.target.value

        if (this.fieldRules[field] === 'digits') value = value.replace(/[^0-9]/g, '')
        else if (this.fieldRules[field] === 'decimal') value = value.replace(/[^0-9\.]/g, '')

        this.setState(prev => {
            return { ...prev, [field]: value }
        })

        this.validators[field] &&
            this.validate({ field, value }).then(res => {
                this.setState({ messages: { ...this.state.messages, [field]: res } })
            })
    }

    handleSelect = e => {
        const [field, value] = e.split('-')

        if (field === 'hmo_id') {
            if (value == 159) this.handleSelect('hmo_plan_id-12277')
            // if (value == 159) this.setState({ hmo_plan_id: '12277' })
            else this.setState({ hmo_plan_id: '' })
        }

        this.setState(prev => {
            return { ...prev, [field]: value }
        })
    }

    cancel = field => {
        this.setState(prev => {
            return { ...prev, [field]: this.props.clientInfo[field] }
        })
    }

    validate = ({ field, value }) => {
        return this.validators[field](value)
    }

    validators = {
        phone: async phone => {
            if (phone.substring(1) === this.props.clientInfo.phone) return ''
            if (phone.length === 10) {
                if (phone[0] == 0) {
                    phone = phone.substring(1)
                }
                return users
                    .checkUnique({ phone })
                    .then(() => '')
                    .catch(() => 'קיים במערכת')
            } else if (phone.length > 10) return 'לא תקין'
            else return ''
        },

        email: async email => {
            if (email === this.props.clientInfo.email || !email) return ''
            return users
                .checkUnique({ email })
                .then(() => '')
                .catch(() => 'קיים במערכת')
        },

        parent_id: async parent_id => {
            if ((parent_id + '').length === 0) return ''
            return users
                .getUser({ user_id: parent_id })
                .then(res => {
                    return `${res.data[0].first_name} ${res.data[0].last_name}`
                })
                .catch(res => {
                    return 'משתמש לא נמצא'
                })
        },

        agency_id: async agency_id => {
            if ((agency_id + '').length === 0) return ''
            return agency
                .getAgency({ license: agency_id })
                .then(res => {
                    return res.data.name
                })
                .catch(err => {
                    return 'רשיון לא נמצא'
                })
        }
    }

    submit = () => {
        const { id } = this.props.clientInfo

        let {
            updateCommission,
            first_name,
            last_name,
            identity,
            passport,
            phone,
            email,
            birthday,
            parent_id,
            status,
            hmo_id,
            hmo_plan_id,
            fathers_name,
            related_as,
            agency_id,
            subscription_price,
            subscription_id,
            card_approval
        } = this.state

        if (identity && !passport && phone.length === 10 && phone[0] == 0) phone = phone.substring(1)

        const payload = {
            id,
            updateCommission,
            first_name,
            last_name,
            identity,
            passport,
            phone: phone,
            email,
            birthday: birthday ? birthday.format('YYYY-MM-DD') : null,
            parent_id,
            status,
            hmo_id: parseInt(hmo_id),
            hmo_plan_id: parseInt(hmo_plan_id),
            fathers_name,
            related_as,
            agency_id,
            subscription_price,
            subscription_id,
            card_approval
        }

        users
            .editUserInfo(payload)
            .then(res => {
                // Wait for the refresh if updateInfo returns a promise, so onClose's
                // setFields() reads the updated client. Otherwise close immediately;
                // the next prop update (same id, new reference, popup closed) refreshes fields.
                const refresh = this.props.updateInfo()
                if (refresh && typeof refresh.then === 'function') {
                    refresh.then(() => this.onClose()).catch(() => this.onClose())
                } else {
                    this.onClose()
                }
            })
            .catch(error => {
                let body = <div></div>
                if (error.response && error.response.data) {
                    body = error.response.data.errorArray.map((error, idx) => {
                        return <p key={idx.toString()}>{this.errors[error.errorCode] || error.errorCode}</p>
                    })
                    body = <div>{body}</div>
                }

                alertPopup({ type: 'error', title: 'אירעה שגיאה. העדכון לא בוצע / לא בוצע באופן מלא', body })
                this.props.updateInfo()
            })
    }

    errors = {
        USER_NOT_FOUND: 'משתמש לא נמצא',
        PARENT_NOT_FOUND: 'משתמש מוביל לא נמצא',
        HMO_PLAN_ERROR: 'תוכנית קופ״ח לא נמצאה/ מתאימה',
        UPDATE_USER_ERROR: 'שגיאה בעדכון פרטי משתמש',
        UPDATE_INVITATION_ERROR: 'שגיאה בעדכון invitation',
        UPDATE_SUBSCRIPTION_PRICE_ERROR: 'שגיאה בעדכון מחיר מנוי',
        UPDATE_COMMISSION_ERROR: 'שגיאה בעדכון עמלה',
        CANCEL_OLD_SUBSCRIPTION_ERROR: 'שגיאה בעת ביטול מנוי',
        CREATE_NEW_SUBSCRIPTION_ERROR: 'שגיאה ביצירת מנוי חדש',
        CANCEL_OLD_COMMISSION_ERROR: 'שגיאה בעת ביטול עמלה',
        CREATE_NEW_COMMISSION_ERROR: 'שגיאה בעת יצירת עמלה',
        CRM_ERROR: 'שגיאת CRM'
    }

    statuses = ['REGISTERED', 'COMPLETE', 'INCOMPLETE', 'BLOCKED', 'DELETED']

    hmoPlans = {
        125: {
            0: '0_ללא',
            1042: '1042_כללית פלטינום',
            1046: '1046_כללית מושלם זהב'
        },
        135: {
            0: '0_ללא',
            1057: '1057_לאומית זהב',
            6368: '6368_לאומית כסף'
        },
        143: {
            0: '0_ללא',
            6369: '6369_מאוחדת שיא',
            8294: '8294_מאוחדת עדיף'
        },
        132: {
            0: '0_ללא',
            6366: '6366_מכבי שלי',
            8295: '8295_מכבי כסף',
            8296: '8296_מכבי זהב'
        },
        142: {},
        159: {
            // 0: 'ללא_0',
            12277: 'תושבי חוץ_12277'
            // 10153: 'תושבי חוץ_10153'
        }
    }

    hmos = {
        125: '125_כללית',
        132: '132_מכבי',
        143: '143_מאוחדת',
        135: '135_לאומית',
        142: '142_משרד הביטחון',
        159: '159_תושבי חוץ'
    }

    relations = {
        PARENT: 'הורה',
        CHILD: 'ילד',
        PARTNER: 'בן/ת זוג'
    }

    fieldRules = {
        first_name: 'letters',
        last_name: 'letters',
        identity: 'digits',
        phone: 'digits',
        parent_id: 'digits',
        agency_id: 'digits',
        subscription_price: 'decimal'
    }

    render() {
        const {
            popupStore: { togglePopup, popupType },
            subscriptionsStore: { subscriptions }
        } = this.props
        const {
            updateCommission,
            first_name,
            last_name,
            identity,
            passport,
            phone,
            email,
            birthday,
            parent_id,
            status,
            hmo_id,
            hmo_plan_id,
            fathers_name,
            related_as,
            agency_id,
            subscription_price,
            subscription_id,
            messages: {
                phone: phoneMessage,
                email: emailMessage,
                parent_id: parentIdMessage,
                agency_id: agencyIdMessage
            }
        } = this.state

        return (
            <>
                <Button onClick={() => togglePopup('editClientInfo')}>{'עריכת פרטים'}</Button>
                {popupType === 'editClientInfo' && (
                    <Modal
                        width={'850px'}
                        onCancel={this.onClose}
                        visible={true}
                        title={
                            <div style={{}}>
                                <span>{'עריכת פרטי משתמש'}</span>
                            </div>
                        }
                        footer={null}
                    >
                        <div style={{ ...style.content }}>
                            <div style={{ ...style.row }}>
                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label }}>{'שם פרטי:'}</span>
                                    <Input
                                        style={{ ...style.rightBox }}
                                        id="input-first_name"
                                        value={first_name}
                                        onChange={this.handleInput}
                                    />
                                    <div
                                        onClick={() => this.cancel('first_name')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>

                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label2 }}>{'קופ״ח:'}</span>
                                    {/* <Select value={hmo_id || undefined} onChange={(e) => this.handleSelect(`hmo_id-${e}`)} style={{ width: '225px' }}>
                                        {Object.values(this.hmos).map((item, idx) => <Select.Option value={item} key={idx.toString()}>{item}</Select.Option>)}
                                    </Select> */}

                                    <Select
                                        value={hmo_id || undefined}
                                        onChange={e => this.handleSelect(`hmo_id-${e}`)}
                                        style={{ width: '225px' }}
                                    >
                                        {Object.keys(this.hmos).map((item, idx) => (
                                            <Select.Option value={item} key={idx.toString()}>
                                                {this.hmos[item]}
                                            </Select.Option>
                                        ))}
                                    </Select>

                                    <div
                                        onClick={() => this.cancel('hmo_id')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>
                            </div>

                            <div style={{ ...style.row }}>
                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label }}>{'שם משפחה:'}</span>
                                    <Input
                                        style={{ ...style.rightBox }}
                                        id="input-last_name"
                                        value={last_name}
                                        onChange={this.handleInput}
                                    />
                                    <div
                                        onClick={() => this.cancel('last_name')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>

                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label2 }}>{'שב״ן:'}</span>
                                    {/* {hmo_id ?
                                        <Select value={hmo_plan_id} onChange={(e) => this.handleSelect(`hmo_plan_id-${e}`)} style={{ width: '225px' }}>
                                            {Object.values(this.hmoPlans[(hmo_id || '').split('_')[0]] || {}).map((item, idx) => <Select.Option value={item} key={idx.toString()}>{item}</Select.Option>)}
                                        </Select>
                                        :
                                        <Select disabled style={{ width: '225px' }}></Select>} */}

                                    {hmo_id ? (
                                        <Select
                                            value={hmo_plan_id}
                                            onChange={e => this.handleSelect(`hmo_plan_id-${e}`)}
                                            style={{ width: '225px' }}
                                        >
                                            {Object.keys(this.hmoPlans[hmo_id] || {}).map((item, idx) => (
                                                <Select.Option value={item} key={idx.toString()}>
                                                    {this.hmoPlans[hmo_id][item]}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    ) : (
                                        <Select disabled style={{ width: '225px' }}></Select>
                                    )}

                                    <div
                                        onClick={() => this.cancel('hmo_plan_id')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>
                            </div>

                            <div style={{ ...style.row }}>
                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label }}>{'מספר זהות:'}</span>
                                    {!passport ? (
                                        <Input
                                            style={{ ...style.rightBox }}
                                            id="input-identity"
                                            value={identity}
                                            onChange={this.handleInput}
                                        />
                                    ) : (
                                        <Input disabled style={{ ...style.rightBox }} />
                                    )}
                                    <div
                                        onClick={() => this.cancel('identity')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>

                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label2 }}>{'סטטוס:'}</span>
                                    <Select
                                        value={status}
                                        onChange={e => this.handleSelect(`status-${e}`)}
                                        style={{ width: '225px' }}
                                    >
                                        {this.statuses.map((item, idx) => (
                                            <Select.Option value={item} key={idx.toString()}>
                                                {item}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                    <div
                                        onClick={() => this.cancel('status')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>
                            </div>

                            <div style={{ ...style.row }}>
                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label }}>{'דרכון:'}</span>
                                    {!identity ? (
                                        <Input
                                            style={{ ...style.rightBox }}
                                            id="input-passport"
                                            value={passport}
                                            onChange={this.handleInput}
                                        />
                                    ) : (
                                        <Input disabled style={{ ...style.rightBox }} />
                                    )}
                                    <div
                                        onClick={() => this.cancel('passport')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>

                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label2 }}>{'מנוי:'}</span>

                                    <Select
                                        value={subscription_id}
                                        onChange={e => this.handleSelect(`subscription_id-${e}`)}
                                        style={{ width: '225px', overflowX: 'auto' }}
                                    >
                                        {subscriptions.map((sub, index) => (
                                            <Select.Option
                                                style={{ paddingInline: '0' }}
                                                title={sub.name}
                                                value={sub.id}
                                                key={index.toString()}
                                            >
                                                {sub.name}
                                            </Select.Option>
                                        ))}
                                    </Select>

                                    <div
                                        onClick={() => this.cancel('subscription_id')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>
                            </div>

                            <div style={{ ...style.row }}>
                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label2 }}>{'טלפון:'}</span>
                                    <Input
                                        style={{ ...style.rightHalfBox, width: `${phoneMessage ? '130px' : '225px'}` }}
                                        id="input-phone"
                                        value={phone}
                                        onChange={this.handleInput}
                                    />
                                    {phoneMessage && (
                                        <div style={{ ...style.box, ...style.messageBox }}>{phoneMessage}</div>
                                    )}
                                    <div
                                        onClick={() => this.cancel('phone')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>

                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label2 }}>{'מחיר מנוי:'}</span>
                                    <Input
                                        style={{ ...style.rightHalfBox, width: '100px' }}
                                        id="input-subscription_price"
                                        value={subscription_price}
                                        onChange={this.handleInput}
                                    />
                                    <div style={{ ...style.box, ...style.messageBox, width: '125px' }}>
                                        <Checkbox
                                            checked={updateCommission}
                                            onChange={e => this.setState({ updateCommission: e.target.checked })}
                                        />
                                        <span style={{ color: '#515151', marginRight: '10px' }}>{'עדכון עמלה'}</span>
                                    </div>
                                    <div
                                        onClick={() => this.cancel('subscription_price')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>
                            </div>

                            <div style={{ ...style.row }}>
                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label2 }}>{'מייל:'}</span>
                                    <Input
                                        style={{ ...style.rightHalfBox, width: `${emailMessage ? '130px' : '225px'}` }}
                                        id="input-email"
                                        value={email}
                                        onChange={this.handleInput}
                                    />
                                    {emailMessage && (
                                        <div style={{ ...style.box, ...style.messageBox }}>{emailMessage}</div>
                                    )}
                                    <div
                                        onClick={() => this.cancel('email')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>

                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label2 }}>{'מזהה מוביל:'}</span>
                                    <Input
                                        style={{
                                            ...style.rightHalfBox,
                                            width: `${parentIdMessage ? '130px' : '225px'}`
                                        }}
                                        id="input-parent_id"
                                        value={parent_id}
                                        onChange={this.handleInput}
                                    />
                                    {parentIdMessage && (
                                        <div style={{ ...style.box, ...style.messageBox }}>{parentIdMessage}</div>
                                    )}
                                    <div
                                        onClick={() => this.cancel('parent_id')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>
                            </div>

                            <div style={{ ...style.row }}>
                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label2 }}>{'תאריך לידה:'}</span>
                                    <DatePicker
                                        value={birthday}
                                        onChange={date => this.setState({ birthday: date })}
                                        format={'DD/MM/YYYY'}
                                        style={{ width: '225px', border: '0px' }}
                                    />

                                    <div
                                        onClick={() => this.cancel('birthday')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>

                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label2 }}>{'שיוך משפחתי:'}</span>
                                    {parent_id ? (
                                        <Select
                                            value={related_as}
                                            onChange={e => this.handleSelect(`related_as-${e}`)}
                                            style={{ width: '225px' }}
                                        >
                                            {Object.keys(this.relations).map((item, idx) => (
                                                <Select.Option value={item} key={idx.toString()}>
                                                    {this.relations[item]}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    ) : (
                                        <Select disabled style={{ width: '225px' }}></Select>
                                    )}
                                    <div
                                        onClick={() => this.cancel('related_as')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>
                                {/* <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label2 }}>{"מזהה סוכנות:"}</span>
                                    <Input style={{ ...style.rightHalfBox, width: `${agencyIdMessage ? '130px' : '225px'}` }} id="input-agency_id" value={agency_id} onChange={this.handleInput} />
                                    {agencyIdMessage &&
                                        <div style={{ ...style.box, ...style.messageBox, paddingTop: '30px' }}>{agencyIdMessage}</div>}
                                    <div onClick={() => this.cancel('agency_id')} style={{ ...style.box, ...style.leftBox  }}>{"איפוס"}</div>
                                </div> */}
                            </div>

                            <div style={{ ...style.row }}>
                                <div style={{ ...style.inputCell }}>
                                    <span style={{ ...style.label }}>{'שם האב:'}</span>
                                    <Input
                                        style={{ ...style.rightBox }}
                                        id="input-fathers_name"
                                        value={fathers_name}
                                        onChange={this.handleInput}
                                    />
                                    <div
                                        onClick={() => this.cancel('fathers_name')}
                                        style={{ ...style.box, ...style.leftBox }}
                                    >
                                        {'איפוס'}
                                    </div>
                                </div>
                            </div>

                            <Button style={{ alignSelf: 'center', marginTop: '20px' }} onClick={this.submit}>
                                {'submit'}
                            </Button>
                        </div>
                    </Modal>
                )}
            </>
        )
    }
}

const style = {
    content: { display: 'flex', flexDirection: 'column' },
    row: { display: 'flex', justifyContent: 'space-between' },
    inputCell: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    label: { width: '120px' },
    label2: { width: '73px' },
    box: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '32px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '0.3rem',
        cursor: 'pointer'
    },
    rightBox: { borderRadius: '0 4px 4px 0' },
    leftBox: { borderRadius: '4px 0 0 4px' },
    rightHalfBox: { borderRadius: '0 4px 4px 0', borderLeft: 'none', width: '130px' },
    messageBox: {
        color: 'red',
        borderRight: 'none',
        lineHeight: '1',
        fontSize: '12px',
        width: '95px',
        overflowY: 'auto'
    }
}

export default withRouter(EditClientInfo)
